"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-console */
const DOCS_BASE_URL = 'https://github.com/amalgamaco/mobx-form/blob/main/docs';
function docsUrl(path) {
    return DOCS_BASE_URL + path;
}
function joinSentences(...sentences) {
    return sentences.filter(Boolean).join('. ');
}
function deprecatedMethod(klass, method, { alternative, docsPath } = {}) {
    const deprecationMessage = joinSentences(`DEPRECATED method '${method}' from class '${klass}'`, alternative && `Use '${alternative}' instead`, docsPath && `For more information about usage see ${docsUrl(docsPath)}`);
    console.warn(`mobx-form: ${deprecationMessage}`);
}
exports.default = deprecatedMethod;
